var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',[[_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.title},[_c('td',{staticClass:"name"},[_vm._v(_vm._s(item.name)+":")]),_c('td',[_vm._v(" "+_vm._s(item.value)+" ")])])}),0)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }